export const ADDRESS_MULTIPLE_GET = "@common/ADDRESS_MULTIPLE_GET";
export const ADDRESS_MULTIPLE_GETCEPCIDADE = "@common/ADDRESS_MULTIPLE_GETCEPCIDADE";
export const ADDRESS_MULTIPLE_SET = "@common/ADDRESS_MULTIPLE_SET";
export const ADDRESS_MULTIPLE_RESET = "@common/ADDRESS_MULTIPLE_RESET";
export const ADDRESS_MULTIPLE_FILTERTYPE_SET = "@common/ADDRESS_MULTIPLE_FILTERTYPE_SET";
export const ADDRESS_MULTIPLE_HASH_SET = "@common/ADDRESS_MULTIPLE_HASH_SET";